import Link from '../Link';
import Image from '../Image';

const defaultProps = {
	image: Image.DefaultProps,
	link: Link.DefaultProps,
};

export default defaultProps;
